/*
 Convention: https://docs.google.com/document/d/1ePqfM41II2CNBYpTuOgjLZafRkn6vABQ5NF40JGER1E/edit
 Review Reference: https://docs.google.com/document/d/1Diu8ZwKXPOWCsH2ry8rufCYADGFcHtR4MY3k1c3Ypes/edit

 ! Review
 TODO Disbursement - change to TS
 */
import auth from 'src/utilities/auth';
import { defaultAction } from '../types';

const initialState = {
  data: {
    campaign_name: '',
    description: '',
    filename: '',
    username: auth?.user?.company_username,
    using_balance: 'mybalance',
    type: 'transfer',
    sms_template: '',
    campaign_create_by: auth?.user?.username,
    is_scheduled: 'false',
    scheduled_time: '',
    category_id: '',
    integration_data: {},
  },
  batchValidation: {
    totalBatch: 0,
    totalBatchFinish: 0,
    validatedBatch: [],
    isNameMatching: true,
  },
  activeCoachmark: true,
  fileHeader: [],
  fileData: [],
  rawFileData: [],
  fileDataTemp: {},
  fileDataSanitize: [],
  fileDataError: [],
  fileDataAllErrorTemp: [],
  fileDataErrorTemp: {},
  responseValidationError: [],
  responseValidationErrorTemp: [],
  isDataTableInputError: false,
  isDataValidated: false,
  isValidationFinished: false,
  isSubmittingDisbursement: false,
  isValidateDataAndNameMatching: false,
  hasChosenValidationFlow: false,
  totalDataInvalid: 0,
  totalDataNotMatched: 0,
  enabledValidateButton: false,
  isValidateClicked: false,
  indexStep: 0,
  currentRowId: 0,
  indexData: 0,
  totalErrorDataFixed: 0,
  batch: [],
  groupKeyList: [],
  requestBaseId: '',
  update_log: [],
  lastRequestBaseId: '',
  lastCurrentBatch: 0,
  totalAdminFee: 0,
  totalTax: 0,
};

const createBulkDisbursementReducer = (
  state = initialState,
  action = defaultAction,
) => {
  switch (action.type) {
    case 'RESET_FILE_DATA_INQUIRY':
      return {
        ...state,
        fileData: state.fileData.map(file => {
          return {
            ...file,
            account_name: '',
          };
        }),
      };
    case 'ADD_TOTAL_ADMIN_FEE':
      return {
        ...state,
        totalAdminFee: state.totalAdminFee + action.payload.totalAdminFee,
      };
    case 'ADD_TOTAL_TAX':
      return {
        ...state,
        totalTax: state.totalTax + action.payload.totalTax,
      };
    case 'RESET_TAX_ADMIN_FEE':
      return {
        ...state,
        totalTax: 0,
        totalAdminFee: 0,
      };
    case 'SET_LAST_REQUEST_BASE_ID':
      return {
        ...state,
        lastRequestBaseId: action.payload.lastRequestBaseId,
      };
    case 'RESET_LAST_REQUEST_BASE_ID':
      return {
        ...state,
        lastRequestBaseId: '',
      };
    case 'SET_CURRENT_BATCH':
      return {
        ...state,
        lastCurrentBatch: action.payload.lastCurrentBatch,
      };
    case 'RESET_CURRENT_BATCH':
      return {
        ...state,
        lastCurrentBatch: 0,
      };

    case 'UPDATE_LOG':
      return {
        ...state,
        update_log: [...state.update_log, ...action.payload.update_log],
      };
    case 'RESET_LOG':
      return {
        ...state,
        update_log: [],
      };
    case 'UPDATE_BATCH':
      const newData = state.batch.map(b => {
        if (b.requestId === action.payload.requestId) {
          return {
            ...b,
            data: action.payload.data,
            status: action.payload.status,
            data_uploaded: action.payload.data_uploaded,
          };
        }
        return b;
      });

      return {
        ...state,
        batch: newData,
      };
    case 'RESET_BATCH':
      return {
        ...state,
        batch: initialState.batch,
      };
    case 'RESET_REQUEST_BASE_ID':
      return {
        ...state,
        requestBaseId: '',
      };
    case 'SET_REQUEST_BASE_ID':
      return {
        ...state,
        requestBaseId: action.payload.requestBaseId,
      };
    case 'SET_BATCH':
      const duplicate = state.batch.some(
        b => b.requestId === action.payload.requestId,
      );
      if (duplicate) {
        return {
          ...state,
          batch: state.batch,
        };
      }
      return {
        ...state,
        batch: [...state.batch, action.payload],
      };
    case 'RESET_BATCH_VALIDATION':
      return {
        ...state,
        batchValidation: {
          totalBatch: 0,
          totalBatchFinish: 0,
          isNameMatching: true,
          validatedBatch: [],
        },
      };
    case 'SET_INIT_BATCH_VALIDATION':
      return {
        ...state,
        batchValidation: {
          ...state.batchValidation,
          totalBatch: action.payload.totalBatch,
          isNameMatching: action.payload.isNameMatching,
        },
      };
    case 'INCREMENT_BATCH_FINISH':
      return {
        ...state,
        batchValidation: {
          ...state.batchValidation,
          validatedBatch: [
            ...state.batchValidation.validatedBatch,
            ...action.payload.validatedBatch,
          ],
          totalBatchFinish: state.batchValidation.totalBatchFinish + 1,
        },
      };
    case 'SET_DATA_CATEGORY_ID':
      return {
        ...state,
        data: {
          ...state.data,
          category_id: action.payload,
        },
      };
    case 'SET_DATA_CAMPAIGN': {
      return {
        ...state,
        data: {
          ...state.data,
          campaign_name: action.payload,
        },
      };
    }
    case 'SET_DATA_DESC': {
      return {
        ...state,
        data: {
          ...state.data,
          description: action.payload,
        },
      };
    }
    case 'SET_DATA_SCHEDULING_OPTION': {
      return {
        ...state,
        data: {
          ...state.data,
          is_scheduled: action.payload,
        },
      };
    }
    case 'SET_DATA_SCHEDULING_TIME': {
      return {
        ...state,
        data: {
          ...state.data,
          scheduled_time: action.payload,
        },
      };
    }
    case 'SET_DATA_USERNAME': {
      return {
        ...state,
        data: {
          ...state.data,
          username: action.payload,
        },
      };
    }
    case 'SET_DATA_USING_BALANCE': {
      return {
        ...state,
        data: {
          ...state.data,
          using_balance: action.payload,
        },
      };
    }
    case 'SET_GROUP_KEY_LIST': {
      return {
        ...state,
        groupKeyList: action.payload,
      };
    }
    case 'UPDATE_GROUP_KEY_LIST':
      const newGroupKeyList = state.groupKeyList;
      const payloadKey = action.payload.key;
      if (!newGroupKeyList.includes(payloadKey)) {
        newGroupKeyList.push(payloadKey);
      }
      return {
        ...state,
        groupKeyList: newGroupKeyList,
      };
    case 'RESET_GROUP_KEY_LIST': {
      return {
        ...state,
        groupKeyList: [],
      };
    }
    case 'SET_CURRENT_ROW_ID': {
      return {
        ...state,
        currentRowId: action.payload,
      };
    }
    case 'SET_TOTAL_ERROR_DATA_FIXED': {
      return {
        ...state,
        totalErrorDataFixed: action.payload,
      };
    }
    case 'SET_INDEX_DATA': {
      return {
        ...state,
        indexData: action.payload,
      };
    }
    case 'SET_STEP': {
      return {
        ...state,
        indexStep: action.payload,
      };
    }
    case 'SET_FILE':
      return {
        ...state,
        fileHeader: action.payload.fileHeader,
        fileData: action.payload.fileData,
        rawFileData: action.payload.fileData,
      };
    case 'SET_DATA': {
      const {
        campaign_name,
        description,
        filename,
        username,
        scheduled_time,
        is_scheduled,
        campaign_create_by,
        integration_data,
        category_id,
      } = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          campaign_name,
          description,
          filename,
          username,
          scheduled_time,
          is_scheduled,
          campaign_create_by,
          integration_data,
          category_id,
        },
      };
    }
    case 'RESET_DATA':
      return {
        ...initialState,
        groupKeyList: [],
      };
    case 'RESET_UPLOADED_DATA':
      return {
        ...state,
        fileDataError: initialState.fileDataError,
        responseValidationError: initialState.responseValidationError,
        isDataTableInputError: initialState.isDataTableInputError,
        isDataValidated: initialState.isDataValidated,
        isValidationFinished: initialState.isValidationFinished,
        isSubmittingDisbursement: initialState.isSubmittingDisbursement,
        isValidateDataAndNameMatching:
          initialState.isValidateDataAndNameMatching,
        hasChosenValidationFlow: initialState.hasChosenValidationFlow,
        totalDataInvalid: initialState.totalDataInvalid,
        totalDataNotMatched: initialState.totalDataNotMatched,
        enabledValidateButton: initialState.enabledValidateButton,
        isValidateClicked: initialState.isValidateClicked,
      };
    case 'SET_DATA_TABLE_INPUT_ERROR':
      return {
        ...state,
        isDataTableInputError: true,
      };
    case 'SET_DATA_TABLE_INPUT_NO_ERROR':
      return {
        ...state,
        isDataTableInputError: false,
      };
    case 'SET_FILE_DATA_VALIDATION_ERROR': {
      const { data } = action.payload;
      const fileDataError = data.map(payloadElem => {
        const obj = state.fileData.find(
          fileDataElem => fileDataElem.row_id === payloadElem.row_id,
        );
        return obj;
      });

      return {
        ...state,
        fileDataError,
        responseValidationError: data,
      };
    }

    case 'SET_FILE_DATA_VALIDATION_ERROR_AND_MISSMATCH': {
      const { data } = action.payload;
      const fileDataError = data.map(payloadElem => {
        const obj = state.fileData.find(
          fileDataElem => fileDataElem.row_id === payloadElem.row_id,
        );
        return {
          ...obj,
          match: payloadElem.match,
        };
      });

      return {
        ...state,
        fileDataError,
        responseValidationError: data,
      };
    }

    case 'SET_FILE_DATA_VALIDATION_ERROR_TEMP': {
      // TODO_BULK: DELETE SOON! Only use this new validation flow for ticket.com
      const { data } = action.payload;

      const prevData = state.fileDataError.find(
        fileDataElem => fileDataElem.row_id === data.row_id,
      );
      const dataError = {
        ...prevData,
        account_name:
          data.account_number !== undefined
            ? ''
            : data.account_name !== undefined
            ? data.account_name
            : prevData.account_name,
        checked: false,
        match: data.match,
        success: data.success,
        tax: data.tax,
        base_admin_fee: data.base_admin_fee,
      };

      const fileDataError = state.fileDataError.map(d => {
        if (d.row_id === dataError.row_id) {
          return dataError;
        }
        return d;
      });

      const fileData = state.fileData.map(d => {
        if (d.row_id === dataError.row_id) {
          return dataError;
        }
        return d;
      });

      const validationError = state.responseValidationError.map(d => {
        if (d.row_id === data.row_id) {
          return data;
        }
        return d;
      });
      const fileErrorInquiryFailed = fileDataError.filter(
        d =>
          !d.success &&
          d.match | (!d.success && !d.match && d.account_name === ''),
      );
      const fileErrorInquirySuccess = fileDataError.filter(
        d => !d.success && !d.match && d.account_name !== '',
      );
      const fileErrorNotMatched = fileDataError.filter(
        d => d.success && !d.match,
      );

      const validationInquiryFailed = validationError.filter(
        d =>
          !d.success &&
          d.match | (!d.success && !d.match && d.account_name === undefined),
      );
      const validationInquirySuccess = validationError.filter(
        d => !d.success && !d.match && d.account_name !== undefined,
      );
      const validationNotMatched = validationError.filter(
        d => d.success && !d.match,
      );
      return {
        ...state,
        fileDataError: state.isValidateDataAndNameMatching
          ? [
              ...fileErrorInquiryFailed,
              ...fileErrorInquirySuccess,
              ...fileErrorNotMatched,
            ]
          : fileDataError,
        fileData,
        responseValidationError: state.isValidateDataAndNameMatching
          ? [
              ...validationInquiryFailed,
              ...validationInquirySuccess,
              ...validationNotMatched,
            ]
          : validationError,
      };
    }

    case 'SET_FILE_DATA_VALIDATION_ERROR_TEMP_MODAL': {
      const { data } = action.payload;
      const prevData = state.fileDataAllErrorTemp.find(
        fileDataElem => fileDataElem.row_id === data.row_id,
      );
      const dataError = {
        ...prevData,
        account_name:
          data.account_name !== undefined
            ? data.account_name
            : prevData.account_name,
        checked: false,
        match: data.match,
        success: data.success,
      };

      const fileDataError = state.fileDataError.map(d => {
        if (d.row_id === dataError.row_id) {
          return dataError;
        }
        return d;
      });

      const fileData = state.fileData.map(d => {
        if (d.row_id === dataError.row_id) {
          return dataError;
        }
        return d;
      });

      const validationError = state.responseValidationError.map(d => {
        if (d.row_id === data.row_id) {
          return data;
        }
        return d;
      });

      const fileErrorInquiryFailed = fileDataError.filter(
        d =>
          (!d.success && d.match) ||
          (!d.success && !d.match && d.account_name === ''),
      );
      const fileErrorInquirySuccess = fileDataError.filter(
        d => !d.success && !d.match && d.account_name !== '',
      );
      const fileErrorNotMatched = fileDataError.filter(
        d => d.success && !d.match,
      );

      const validationInquiryFailed = validationError.filter(
        d =>
          !d.success &&
          d.match | (!d.success && !d.match && d.account_name === undefined),
      );
      const validationInquirySuccess = validationError.filter(
        d => !d.success && !d.match && d.account_name !== undefined,
      );
      const validationNotMatched = validationError.filter(
        d => d.success && !d.match,
      );

      return {
        ...state,
        fileDataError: state.isValidateDataAndNameMatching
          ? [
              ...fileErrorInquiryFailed,
              ...fileErrorInquirySuccess,
              ...fileErrorNotMatched,
            ]
          : fileDataError,
        fileData,
        responseValidationError: state.isValidateDataAndNameMatching
          ? [
              ...validationInquiryFailed,
              ...validationInquirySuccess,
              ...validationNotMatched,
            ]
          : validationError,
        responseValidationErrorTemp: validationError,
      };
    }
    case 'SET_FILE_DATA_TEMP': {
      return {
        ...state,
        fileDataTemp: state.fileData.find(f => f.row_id === action.payload),
      };
    }
    case 'RESET_FILE_DATA_TEMP': {
      return {
        ...state,
        fileDataTemp: {},
      };
    }
    case 'SET_FILE_DATA_ALL_ERROR': {
      return {
        ...state,
        fileDataAllErrorTemp: state.fileDataError,
        responseValidationErrorTemp: state.responseValidationError,
      };
    }
    case 'RESET_FILE_DATA_ALL_ERROR': {
      return {
        ...state,
        fileDataAllErrorTemp: [],
        responseValidationErrorTemp: [],
      };
    }
    case 'SET_FILE_DATA_ERROR_TEMP': {
      return {
        ...state,
        fileDataErrorTemp: state.fileDataError.find(
          f => f.row_id === action.payload,
        ),
      };
    }
    case 'SET_FILE_DATA_ERROR_TEMP_MODAL': {
      return {
        ...state,
        fileDataErrorTemp: state.fileDataAllErrorTemp.find(
          f => f.row_id === action.payload,
        ),
      };
    }
    case 'RESET_FILE_DATA_ERROR_TEMP': {
      return {
        ...state,
        fileDataErrorTemp: {},
      };
    }
    case 'RESET_FILE_DATA_MATCH_SUCCESS':
      const newFileData = state.fileData.map(f => {
        return {
          ...f,
          match: false,
          success: false,
        };
      });
      return {
        ...state,
        fileData: newFileData,
      };
    case 'RESET_FILE_DATA_VALIDATION_ERROR':
      return {
        ...state,
        fileDataError: initialState.fileDataError,
        responseValidationError: initialState.responseValidationError,
      };
    case 'RESET_FILE_DATA_VALIDATION_ERROR_TEMP':
      const fileDataError = state.fileDataError.filter(
        f => !(f.row_id === action.payload),
      );
      const responseValidationError = state.responseValidationError.filter(
        f => !(f.row_id === action.payload),
      );
      return {
        ...state,
        fileDataError: fileDataError,
        responseValidationError: responseValidationError,
      };
    case 'SET_RESULT_INQUIRY_VALIDATED_DATA': {
      const newFileData = state.fileData.map(data => {
        const obj = action.payload.find(i => i.row_id === data.row_id);
        const objData = state.fileDataError.find(i => i.row_id === data.row_id);
        if (obj && obj.account_name && objData && state.isValidateClicked) {
          return {
            ...objData,
            match: obj.match,
            edited: false,
            account_name: obj.account_name,
            success: obj.success,
          };
        }
        if (obj && obj.account_name) {
          return {
            ...data,
            match: obj.match,
            account_name: obj.account_name,
            success: obj.success,
          };
        }
        return data;
      });
      return {
        ...state,
        fileData: newFileData,
      };
    }
    case 'SET_RESULT_INQUIRY_VALIDATED_DATA_2': {
      const newFileData = state.fileData.map(data => {
        const obj = action.payload.find(i => i.row_id === data.row_id);
        const objData = state.fileDataError.find(i => i.row_id === data.row_id);
        if (obj && obj.account_name && objData && state.isValidateClicked) {
          return {
            ...objData,
            match: obj.match,
            edited: false,
            account_name: obj.account_name,
            success: obj.success,
            group_key: obj?.group_key ?? '',
            base_admin_fee: obj?.base_admin_fee ?? 0,
            tax: obj?.tax ?? 0,
          };
        }
        if (obj && obj.account_name) {
          return {
            ...data,
            match: obj.match,
            account_name: obj.account_name,
            success: obj.success,
            group_key: obj?.group_key ?? '',
            base_admin_fee: obj?.base_admin_fee ?? 0,
            tax: obj?.tax ?? 0,
          };
        }
        return {
          ...data,
          group_key: obj?.group_key ?? '',
          base_admin_fee: obj?.base_admin_fee ?? 0,
          tax: obj?.tax ?? 0,
        };
      });
      return {
        ...state,
        fileData: newFileData,
      };
    }
    case 'SET_RESULT_INQUIRY_VALIDATED_DATA_TEMP': {
      const newFileData = state.fileData.map(data => {
        const obj = action.payload.item.find(i => i.row_id === data.row_id);
        const objData = state.fileDataError.find(i => i.row_id === data.row_id);
        if (
          data.row_id === action.payload.row_id &&
          Object.keys(state.fileDataErrorTemp).length !== 0
        ) {
          return {
            ...state.fileDataErrorTemp,
            checked: false,
            edited: false,
            account_name: obj.account_name,
            success: obj.success,
            match: action.payload.match,
            base_admin_fee: obj?.base_admin_fee ?? 0,
            tax: obj?.tax ?? 0,
          };
        }
        if (obj && obj.account_name && objData && state.isValidateClicked) {
          return {
            ...objData,
            checked: false,
            edited: false,
            account_name: obj.account_name,
            success: obj.success,
            base_admin_fee: obj?.base_admin_fee ?? 0,
            tax: obj?.tax ?? 0,
          };
        }
        if (obj && obj.account_name) {
          return {
            ...data,
            checked: false,
            account_name: obj.account_name,
            success: obj.success,
            base_admin_fee: obj?.base_admin_fee ?? 0,
            tax: obj?.tax ?? 0,
          };
        }
        return data;
      });

      if (action.payload.success && action.payload.match) {
        return {
          ...state,
          fileDataTemp: newFileData.find(
            f => f.row_id === action.payload.row_id,
          ),
          fileDataErrorTemp: {},
          fileData: newFileData,
        };
      } else
        return {
          ...state,
          fileDataErrorTemp: newFileData.find(
            f => f.row_id === action.payload.row_id,
          ),
          fileDataTemp: {},
          fileData: newFileData,
        };
    }

    case 'SET_RESULT_INQUIRY_VALIDATED_DATA_TEMP_MODAL': {
      const newFileData = state.fileData.map(data => {
        const obj = action.payload.item.find(i => i.row_id === data.row_id);
        const objData = state.fileDataAllErrorTemp.find(
          i => i.row_id === data.row_id,
        );
        if (
          data.row_id === action.payload.row_id &&
          Object.keys(state.fileDataErrorTemp).length !== 0
        ) {
          return {
            ...state.fileDataErrorTemp,
            checked: false,
            edited: false,
            account_name: obj.account_name,
            success: obj.success,
            match: action.payload.match,
            base_admin_fee: obj?.base_admin_fee ?? 0,
            tax: obj?.tax ?? 0,
          };
        }
        if (obj && obj.account_name && objData && state.isValidateClicked) {
          return {
            ...objData,
            edited: false,
            checked: false,
            account_name: obj.account_name,
            success: obj.success,
            match: data.match,
            base_admin_fee: obj?.base_admin_fee ?? 0,
            tax: obj?.tax ?? 0,
          };
        }
        if (obj && obj.account_name) {
          return {
            ...data,
            checked: false,
            account_name: obj.account_name,
            success: obj.success,
            base_admin_fee: obj?.base_admin_fee ?? 0,
            tax: obj?.tax ?? 0,
          };
        }
        return {
          ...data,
          checked: false,
        };
      });

      if (action.payload.success && action.payload.match) {
        return {
          ...state,
          fileDataTemp: newFileData.find(
            f => f.row_id === action.payload.row_id,
          ),
          fileDataErrorTemp: {},
          fileData: newFileData,
        };
      } else {
        return {
          ...state,
          fileDataErrorTemp: newFileData.find(
            f => f.row_id === action.payload.row_id,
          ),
          fileDataTemp: {},
          fileData: newFileData,
        };
      }
    }
    case 'SET_RESULT_NAME_MATCHED_DATA': {
      const newFile = state.fileData.map(data => {
        const isPayloadFound =
          action.payload.findIndex(item => item.row_id === data.row_id) >= 0;
        const isDataErrorFound =
          state.fileDataError.findIndex(i => i.row_id === data.row_id) >= 0;
        if (isPayloadFound || isDataErrorFound) {
          return {
            ...data,
            edited: false,
            match: true,
          };
        }
        return data;
      });
      return {
        ...state,
        fileData: newFile,
      };
    }
    case 'SET_RESULT_NAME_MATCHED_DATA_TEMP': {
      const newFile = state.fileData.map(data => {
        const isPayloadFound =
          action.payload.findIndex(item => item.row_id === data.row_id) >= 0;
        if (isPayloadFound) {
          return {
            ...data,
            checked: false,
            edited: false,
            match: data.match,
          };
        }
        return data;
      });
      return {
        ...state,
        fileData: newFile,
      };
    }

    case 'SET_ALL_DATA_VALIDATED':
      return {
        ...state,
        isDataValidated: true,
      };
    case 'RESET_ALL_DATA_VALIDATED':
      return {
        ...state,
        isDataValidated: false,
        isValidationFinished: false,
        totalDataInvalid: 0,
        totalDataNotMatched: 0,
        enabledValidateButton: false,
        isValidateClicked: false,
      };
    case 'SET_VALIDATION_FINISHED':
      return {
        ...state,
        isValidationFinished: true,
      };
    case 'SET_SUBMITTING_DISBURSEMENT':
      return {
        ...state,
        isSubmittingDisbursement: true,
      };
    case 'RESET_SUBMITTING_DISBURSEMENT':
      return {
        ...state,
        isSubmittingDisbursement: false,
      };
    case 'UPDATE_FILE_DATA_UPLOAD':
      return {
        ...state,
        fileData: action.payload,
      };
    case 'UPDATE_FILE_DATA_UPLOAD_ERROR_VALIDATION':
      return {
        ...state,
        fileDataError: action.payload,
      };
    case 'UPDATE_FILE_DATA_UPLOAD_ERROR_VALIDATION_MODAL':
      return {
        ...state,
        fileDataAllErrorTemp: action.payload,
      };
    case 'UPDATE_FILE_DATA_UPLOAD_ERROR_VALIDATION_TEMP':
      return {
        ...state,
        fileDataErrorTemp: action.payload,
      };
    case 'UPDATE_FILE_DATA_UPLOAD_VALIDATION_TEMP':
      return {
        ...state,
        fileDataTemp: action.payload,
      };
    case 'SET_INPUT_CELL_DATA_CHANGED': {
      const { row_id } = action.payload;
      const { item } = action.payload;
      const newData = state.fileData.map(data => {
        if (data.row_id === row_id) {
          return item;
        }
        return data;
      });
      return {
        ...state,
        fileData: newData,
      };
    }
    case 'SET_INPUT_CELL_DATA_CHANGED_TEMP': {
      return {
        ...state,
        fileDataTemp: action.payload.item,
      };
    }
    case 'SET_INPUT_CELL_DATA_ERROR_CHANGED': {
      const row_id_error = action.payload.row_id;
      const itemError = action.payload.item;
      const newDataError = state.fileDataError.map(data => {
        if (data.row_id === row_id_error) {
          return itemError;
        }
        return data;
      });
      return {
        ...state,
        fileDataError: newDataError,
      };
    }
    case 'SET_INPUT_CELL_DATA_ERROR_CHANGED_TEMP': {
      return {
        ...state,
        fileDataErrorTemp: action.payload.item,
      };
    }
    case 'SET_VALIDATE_DATA_AND_NAME_MATCHING':
      return {
        ...state,
        isValidateDataAndNameMatching: true,
      };
    case 'RESET_VALIDATE_DATA_AND_NAME_MATCHING':
      return {
        ...state,
        isValidateDataAndNameMatching: false,
      };
    case 'SET_TOTAL_DATA_INVALID':
      return {
        ...state,
        totalDataInvalid: action.payload,
      };
    case 'SET_TOTAL_DATA_NOT_MATCH':
      return {
        ...state,
        totalDataNotMatched: action.payload,
      };
    case 'RESET_TOTAL_DATA_INVALID':
      return {
        ...state,
        totalDataInvalid: 0,
      };
    case 'RESET_TOTAL_DATA_NOT_MATCH':
      return {
        ...state,
        totalDataNotMatched: 0,
      };
    case 'SET_HAS_CHOSEN_VALIDATION_FLOW':
      return {
        ...state,
        hasChosenValidationFlow: true,
      };
    case 'SET_ENABLED_VALIDATE_BUTTON':
      return {
        ...state,
        enabledValidateButton: true,
      };
    case 'RESET_ENABLED_VALIDATE_BUTTON':
      return {
        ...state,
        enabledValidateButton: false,
      };
    case 'SET_VALIDATED_DATA_BUT_STILL_INVALID': {
      const newValidatedData = state.fileData.map(data => {
        const obj = action.payload.find(item => item.row_id === data.row_id);
        const objData = state.fileDataError.find(
          i => obj && i.row_id === obj.row_id,
        );
        if (objData && state.isValidateClicked) {
          return {
            ...objData,
            edited: false,
          };
        }
        return data;
      });
      return {
        ...state,
        fileData: newValidatedData,
      };
    }
    case 'SET_VALIDATED_DATA_BUT_STILL_INVALID_TEMP': {
      const data = state.fileData.find(f => f.row_id === action.payload.row_id);

      const newValidatedData = {
        ...data,
        match: action.payload.match,
        success: action.payload.success,
      };
      let validationError = [];
      if (state.responseValidationError.length > 0) {
        validationError = state.responseValidationError;
      }
      validationError.push(action.payload);

      const newFileData = state.fileData.map(f => {
        if (f.row_id === action.payload.row_id) {
          return {
            ...f,
            checked: false,
            match: action.payload.match,
            success: action.payload.success,
          };
        }
        return f;
      });

      if (action.payload.success && action.payload.match) {
        return {
          ...state,
          fileDataTemp: newValidatedData,
          fileData: newFileData,
        };
      } else {
        return {
          ...state,
          fileDataTemp: {},
          fileDataErrorTemp: newValidatedData,
          fileDataError: newFileData.filter(
            f => !f.success || (f.success && !f.match),
          ),
          fileData: newFileData,
          responseValidationError: validationError,
        };
      }
    }
    case 'SET_VALIDATED_DATA_BUT_STILL_INVALID_TEMP_IS_IGNORE_MATCH': {
      const data = state.fileData.find(f => f.row_id === action.payload.row_id);

      const newValidatedData = {
        ...data,
        success: action.payload.success,
      };
      let validationError = [];
      if (state.responseValidationError.length > 0) {
        validationError = state.responseValidationError;
      }
      validationError.push(action.payload);

      const newFileData = state.fileData.map(f => {
        if (f.row_id === action.payload.row_id) {
          return {
            ...f,
            checked: false,
            success: action.payload.success,
          };
        }
        return f;
      });

      if (action.payload.success) {
        return {
          ...state,
          fileDataTemp: newValidatedData,
          fileData: newFileData,
        };
      } else {
        return {
          ...state,
          fileDataTemp: {},
          fileDataErrorTemp: newValidatedData,
          fileDataError: newFileData.filter(f => !f.success),
          fileData: newFileData,
          responseValidationError: validationError,
        };
      }
    }
    case 'SET_IS_VALIDATE_CLICKED':
      return {
        ...state,
        isValidateClicked: true,
      };
    case 'RESET_IS_VALIDATE_CLICKED':
      return {
        ...state,
        isValidateClicked: false,
      };
    case 'INACTIVE_COACHMARK':
      return {
        ...state,
        activeCoachmark: false,
      };
    default:
      return state;
  }
};

export default createBulkDisbursementReducer;
